import "./Body.css";
import brickFlowerBackground from '../assets/images/brickFlowerBackground.png'
import React from "react";



function PageNotFound(props) {

  return (
    <div className="">
        <img src={brickFlowerBackground} alt="brick wall with multiple bouquets on it" className="brickFlowerBackgroundImage" />
        <p className="aboutHeader"> page not found! </p>
         <a className="href" href='/'>
                <p className="navButton forYouFooterButton"> back to home </p>
        </a>
    </div>
  );
}

export default PageNotFound;
